<template>
  <loader-wrapper>
    <div class="stub__content">
      <div class="stub__content_icon pulse">
        <slot name="icon" />
      </div>
      <slot name="title" />
      <!-- <styled-spinner-svg/> -->
    </div>
  </loader-wrapper>
</template>

<script>
import styled from 'vue-styled-components';

// TODO: Why doesnt works keyframes?
// const animation = styled.keyframes`
//   from {
//     transform: rotate(0deg);
//   }
//   to {
//     transform: rotate(360deg);
//   }
// `;

const loaderWrapper = styled.section`
  .stub__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    &_icon {
      border-radius: 50%;
      overflow: hidden;
      margin-bottom: 20px;
    }
  }

  .pulse {
    border-radius: 50%;
    background: var(--secondary_background_color);
    cursor: pointer;
    box-shadow: 0 0 0 rgba(204, 169, 44, 0.4);
    animation: pulse 2s infinite;
  }

  width: 100%;
  height: 100%;
  height: calc(100% - 46px);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 103;
  background-color: var(--secondary_background_color);
`;

export default {
  components: {
    loaderWrapper,
  },
};
</script>

<style>
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 85, 204, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(0, 85, 204, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 85, 204, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 85, 204, 0.4);
    box-shadow: 0 0 0 0 rgba(0, 85, 204, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(0, 85, 204, 0);
    box-shadow: 0 0 0 10px rgba(0, 85, 204, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 85, 204, 0);
    box-shadow: 0 0 0 0 rgba(0, 85, 204, 0);
  }
}
</style>
